import React, { lazy } from 'react';
import { TipsView } from '@shared/ui/tips/TipsView';
import { Versioned } from '@shared/ui/uiVersion';
import { MainLayout } from '../layouts';

// Loaded only when shown, so its global CSS never reaches the new look
const ClassicTipsPage = lazy(() => import('./classic/TipsPage'));

/** A meeting's tips and results: classic, or the shared view in this app's frame (ADR-0008). */
const TipsPage: React.FC = () => (
  <Versioned classic={<ClassicTipsPage />}>
    <MainLayout>
      <TipsView />
    </MainLayout>
  </Versioned>
);

export default TipsPage;
